// src/features/engine/utils/stepUtils.js

export function resolveCurrentStep({
  mode,
  forcedStep,
  programState,
  resolvedSteps
}) {

  const stepKey =
    mode === "dashboard"
      ? (forcedStep || programState?.currentStep)
      : programState?.currentStep;

  if (!stepKey) return null;

  return resolvedSteps.find(s => s.key === stepKey);
}
